import TableContainer from 'components/Common/TableContainer'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Card, CardBody, Col, Container, Input, Label, Row, Modal, ModalBody, ModalHeader, Form, FormGroup, FormFeedback } from 'reactstrap'
import {
    getStateStart,
    getRegStart
} from "store/Policy/action"
import { SrNo, City, RTONO } from './RTOCol'

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
//import ManageRtoReducer from 'store/SuperAdmin/ManageRTO/Reducer'
import Spinners from 'components/Common/Spinner'
import { createSelector } from 'reselect'
import { addNewRto } from 'store/actions'
import { toast } from 'react-toastify'
const MangageRTOAdmin = () => {
    const dispatch = useDispatch();
    const [modal, setModal] = useState({
        isShow: false,
    })
    const [inputData, setInputData] = useState({
        state: "",
        registration_number: "",
        registration_number: ''
    })

    const [rtoList, setRtoList] = useState([])
    const {
        STATE,
        REGISTATION_NUMBER,
    } = useSelector(state => state.PolicyReducer)

const ManageRtoReducer = state => state.ManageRtoReducer
const ManageRtoReducerProperty = createSelector(
    ManageRtoReducer,
    ManageRtoStore => ({
        errors: ManageRtoStore.errors,
        successMsg: ManageRtoStore.successMsg,
        Loading: ManageRtoStore.Loading,
    })
)


const { errors, successMsg, Loading } =
    useSelector(ManageRtoReducerProperty)

    const getStateVal = e => {
        dispatch(getRegStart(e.target.value))
    }

    const handleCloseModal = () => {
        setModal({ ...modal, isShow: false })
    }



    const validation = useFormik({
        // enableReinitialize : use this  flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            state: "" || "",
            city: "" || "",
            registration_number: "" || "",
        },
        validationSchema: Yup.object({
            state: Yup.string().required("Please Select State"),
            city: Yup.string().required("Please Enter City"),
            registration_number: Yup.string().required("Please Enter Registration Number"),
        }),
        onSubmit: values => {
             dispatch(addNewRto(values))
             handleCloseModal();
        },
    })

    useEffect(() => {
        if (errors && errors !== "") {
            toast.error(errors)
        }
        if (successMsg && successMsg !== "") {
            toast.success(successMsg)
            dispatch(getStateStart())
        }
    }, [errors, successMsg])


    useEffect(() => {
        dispatch(getStateStart())
    }, [])

    useEffect(() => {
        if (REGISTATION_NUMBER) {
            if ('data' in REGISTATION_NUMBER) {
                setRtoList(REGISTATION_NUMBER.data)
            }
        }
    }, [REGISTATION_NUMBER])


    const columns = useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: (row, i) => i + 1,
                filterable: true,
                Cell: cellProps => {
                    return <SrNo {...cellProps} />
                },
            },
            {
                Header: "City",
                accessor: "city",
                filterable: true,
                Cell: cellProps => {
                    return <City {...cellProps} />
                },
            },
            {
                Header: "Regestration No",
                accessor: "registration_number",
                filterable: true,
                Cell: cellProps => {
                    return <RTONO {...cellProps} />
                },
            },
        ])

    return (
        <div className='page-content'>
            <Container fluid={true}>
            {
                    Loading ? <Spinners /> :

                <Card>
                    <div className='m-3 d-flex align-items-center justify-content-between'>
                        <h4>Manage RTO</h4>
                        <Button color='primary' onClick={() => setModal({ ...modal, isShow: true })}>Add New RTO</Button>
                    </div>

                    <CardBody>
                        <Row>
                            <Col>
                                <Label for={'stateInput'}>Select States</Label>
                                <Input type='select' name='states' id='stateInput' onChange={e => getStateVal(e)}>
                                    <option>Select State</option>
                                    {STATE && STATE.data ?
                                        STATE.data.map((data, index) => (
                                            <option key={index} value={data.state}>
                                                {data.state}
                                            </option>
                                        )) : null}
                                </Input>
                            </Col>
                        </Row>

                        <div className='mt-5'>


                            <TableContainer
                                columns={columns}
                                data={rtoList}
                                isGlobalFilter={true}
                                isAddOptions={false}

                                isJobListGlobalFilter={false}
                                isPagination={true}
                                iscustomPageSizeOptions={true}
                                isShowingPageLength={true}
                                customPageSize={15}
                                tableClass="table-bordered align-middle nowrap mt-2"
                                paginationDiv="col-sm-12 col-md-7"
                                pagination="pagination justify-content-end pagination-rounded"
                            />
                        </div>
                    </CardBody>
                </Card>}
            </Container>
            

            <Modal isOpen={modal.isShow} toggle={handleCloseModal}>
                <ModalHeader toggle={handleCloseModal} tag={"h4"}>
                    <p>Are You Sure ?</p>
                </ModalHeader>
                <ModalBody>
                    <Form  
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}>
                        <FormGroup>
                            <Label for={'stateInput'}>Select States</Label>
                            <Input
                                type='select'
                                name='state'
                                id='stateInput'
                                placeholder="SELECT CITY"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                    validation.touched.state &&
                                        validation.errors.state
                                        ? true
                                        : false
                                }
                            >
                                <option>Select State</option>
                                {STATE && STATE.data ?
                                    STATE.data.map((data, index) => (
                                        <option key={index} value={data.state}>
                                            {data.state}
                                        </option>
                                    )) : null}
                            </Input>
                            {validation.touched.state &&
                                validation.errors.state ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.state}
                                </FormFeedback>
                            ) : null}

                        </FormGroup>

                        <FormGroup>
                            <Label for='cityInput'>City</Label>
                            <Input
                                name='city'
                                id='cityInput'
                                placeholder="Enter City"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                    validation.touched.city &&
                                        validation.errors.city
                                        ? true
                                        : false
                                }
                            />

                            {validation.touched.city &&
                                validation.errors.city ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.city}
                                </FormFeedback>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for='RTONO'>RTO NO</Label>
                            <Input
                                name='registration_number'
                                id='RTONO'
                                placeholder="Enter RTO"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                    validation.touched.registration_number &&
                                        validation.errors.registration_number
                                        ? true
                                        : false
                                }
                            />

                            {validation.touched.registration_number &&
                                validation.errors.registration_number ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.registration_number}
                                </FormFeedback>
                            ) : null}

                        </FormGroup>

                        <FormGroup>
                            <Button color='primary' type='submit'>Submit</Button>
                        </FormGroup>

                    </Form>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default MangageRTOAdmin